import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Session from "cc-frontend/services/session"
import styles from "./accept.module.css"

export default class AcceptComponent extends Component {
  @service session!: Session
  readonly styles = styles

  @action contactUs() {
    if (window && window["Intercom"]) {
      window["Intercom"]("showNewMessage")
    }
  }
}
